import script from "./CustomerListing.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerListing.vue?vue&type=script&setup=true&lang=js"

import "./CustomerListing.vue?vue&type=style&index=0&id=34e4c84c&lang=css"

const __exports__ = script;

export default __exports__